"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelatedDocument = void 0;
const tslib_1 = require("tslib");
const t = tslib_1.__importStar(require("io-ts"));
exports.RelatedDocument = t.exact(t.intersection([
    t.type({
        typ: t.string,
        id: t.string,
        language: t.string,
        groupLangId: t.string,
    }),
    t.partial({
        uid: t.union([t.string, t.null, t.undefined]),
    }),
]));
